import React, { Fragment, useContext } from 'react';
import { Container, Row, Col, Figure } from 'react-bootstrap';
import RecordContext from '../../context/record/recordContext';
import TopNav from '../nav/TopNav';
import RecordLabelNav from './RecordLabelNav';
import MainFooter from '../nav/MainFooter';
import { NavLink } from 'react-router-dom';

const RecordReleases = () => {
  const recordContext = useContext(RecordContext);
  const { records, moreRecords } = recordContext;
  return (
    <Fragment>
      <Container fluid className='RecordReleases text-capitalize'>
        <TopNav />
        <RecordLabelNav />
        <Container className='my-5'>
          <Row className='RecordReleases-list1'>
            {records.map((record) => (
              <li key={record.id}>
                <img src={record.src} alt='' width='100%' height='100%' />
              </li>
            ))}
          </Row>
          <Row>
            <Col className='RecordReleases-heading1 pl-0'>Rezonate</Col>
          </Row>
          <Row>
            <Col className='RecordReleases-heading2 pl-0'>Jon Casey</Col>
          </Row>
          <Row>
            <p>
              A blend of street culture and futuristic design - a distinctive
              style of clothing for our music community around the world
            </p>
          </Row>
          <Row>
            <Col className='pl-0' md={2}>
              <button className='btn btn-theam'>Explore</button>
            </Col>
          </Row>
        </Container>
      </Container>

      <NavLink to='/cart' className='sticky_cart'>
        <span className='pl-1'>
          <i class='fa fa-shopping-cart' aria-hidden='true' />
          <span className='cart_count'>1</span>
        </span>
        <span className='mx-3 text-capitalize'>
          Go to cart <i className='fa fa-chevron-right' aria-hidden='true' />
        </span>
      </NavLink>

      <div>
        <Container>
          {moreRecords.map((record) => (
            <Figure className='RecordReleases-list2' key={record.id}>
              <Figure.Image
                width={171}
                height={180}
                alt='171x180'
                src={record.src}
              />
              <Row>
                <Col className='RecordReleases-heading2'>{record.heading1}</Col>
              </Row>
              <Figure.Caption>{record.heading2}</Figure.Caption>
            </Figure>
          ))}
          <Row>
            <Col md={{ span: 3, offset: 4 }}>
              <button className='btn btn-black'>load more</button>
            </Col>
          </Row>
        </Container>
      </div>
      <MainFooter />
    </Fragment>
  );
};
export default RecordReleases;
